import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=3b4ba4da&scoped=true&"
import script from "./SearchFilter.vue?vue&type=script&lang=ts&"
export * from "./SearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=3b4ba4da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ba4da",
  null
  
)

export default component.exports